import React, { useState, useEffect } from 'react';
import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';

interface VisibilityToggleProps {
  defaultVisible?: boolean;
  color?: string;
  onToggle?: (visible: boolean) => void;
}

const VisibilityToggle: React.FC<VisibilityToggleProps> = ({
  defaultVisible = false,
  color = '#61d77c',
  onToggle,
}) => {
  const [isVisible, setIsVisible] = useState(defaultVisible);

  const toggleVisibility = () => {
    const newState = !isVisible;
    setIsVisible(newState);
    onToggle?.(newState);
  };

  useEffect(() => {
    setIsVisible(defaultVisible);
  }, [defaultVisible]);

  return (
    <div
      onClick={toggleVisibility}
      role='button'
      aria-label='toggle-visibility'
      style={{ cursor: 'pointer' }}>
      {isVisible ? (
        <EyeFilled rev={undefined} style={{ color }} />
      ) : (
        <EyeInvisibleFilled rev={undefined} />
      )}
    </div>
  );
};

export default VisibilityToggle;
